var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1PhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.67 25.24A32.54 32.54 0 0014 46l-4-.31A36.58 36.58 0 0144.39 12l.23 4a32.55 32.55 0 00-20.95 9.24zm19-1.51l-.47-4c-6 .71-11.09 3.28-16 8.07a28.68 28.68 0 00-8.4 16.65l4 .56A24.65 24.65 0 0129 30.69c4.23-4.14 8.57-6.35 13.66-6.96h.01zm-16.8 17.55l3.77 1.32a17.9 17.9 0 0111.26-11l-1.24-3.8a21.84 21.84 0 00-13.79 13.48zm37.77-20l-3-2.64L48.89 32l4.41 3.88A80.675 80.675 0 0146.46 45a79.858 79.858 0 01-8.16 8l-4.41-3.88-11.77 13.33 3 2.64a3.8 3.8 0 003.71.72l.13-.06.48-.22c6.11-2.82 14.86-9.81 21.11-16.91S62.63 32 64.65 25.53c.06-.174.11-.35.15-.53 0 0 0-.09.05-.14a3.8 3.8 0 00-1.21-3.56v-.02z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Phone_call.b6eba942.svg";
export { SvgH1PhoneCall as ReactComponent };